import { getSelectedStoreOption } from "../../../pages/LandingPage/helpers";
import {
  IAMUserState,
  IOption,
  LaunchMode,
  PaymentsLaunchContext,
} from "../../../types";

interface ResolvePaymentsContextResult {
  launchMode: LaunchMode;
  effectiveEnterpriseId: string;
  effectiveStoreOption: IOption;
  effectiveIamUserState: IAMUserState;
  effectiveIamUserStoresCommaSeparated: string;
}

interface ResolvePaymentsContextParams {
  context?: PaymentsLaunchContext;
  fallbackEnterpriseId: string;
  fallbackStore: IOption;
  fallbackIamUserState: IAMUserState;
  fallbackIamUserStoresCommaSeparated: string;
}

export const resolvePaymentsContext = async ({
  context,
  fallbackEnterpriseId,
  fallbackStore,
  fallbackIamUserState,
  fallbackIamUserStoresCommaSeparated,
}: ResolvePaymentsContextParams): Promise<ResolvePaymentsContextResult> => {
  if (!context) {
    return {
      launchMode: "default",
      effectiveEnterpriseId: fallbackEnterpriseId,
      effectiveStoreOption: fallbackStore,
      effectiveIamUserState: fallbackIamUserState,
      effectiveIamUserStoresCommaSeparated: fallbackIamUserStoresCommaSeparated,
    };
  }

  const { enterpriseId, storeId } = context;

  return {
    launchMode: "payments",
    effectiveEnterpriseId: enterpriseId,
    effectiveStoreOption: getSelectedStoreOption(
      storeId,
      fallbackIamUserState.extendedAccountInfo,
    ),
    effectiveIamUserState: fallbackIamUserState,
    effectiveIamUserStoresCommaSeparated: fallbackIamUserStoresCommaSeparated,
  };
};
